import { Pill } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

import { ChatActionCard } from "../Chat/ChatActionCard";
import { Button } from "../components/Button";

export interface DetectedChartingCredentialsCardProps {
  hasExistingChartingCredentials: boolean;
  onDismiss: () => void;
  onUpdateCredentials: () => void;
}

export function DetectedChartingCredentialsCard(props: DetectedChartingCredentialsCardProps) {
  const { hasExistingChartingCredentials, onDismiss, onUpdateCredentials } = props;

  const updateLoginMessage =
    "It looks like the workplace just shared your charting login. Update the saved login?";
  const saveLoginMessage =
    "It looks like the workplace just shared your charting login. Save this login?";

  return (
    <Box sx={{ position: "relative" }}>
      <ChatActionCard
        sx={(theme) => ({
          zIndex: 5,
          borderColor: theme.palette.shift?.urgent.border,
          position: "absolute",
          boxShadow: theme.shadows[3],
          top: theme.spacing(5),
          left: theme.spacing(5),
          right: theme.spacing(5),
        })}
        pill={
          <Pill
            variant="outlined"
            size="small"
            label="Charting login found"
            backgroundColor={(theme) => theme.palette.background.quaternary}
            color={(theme) => theme.palette.shift?.urgent.text}
            outlineColor={(theme) => theme.palette.shift?.urgent.border}
            sx={{
              width: "fit-content",
            }}
          />
        }
        message={hasExistingChartingCredentials ? updateLoginMessage : saveLoginMessage}
        onClose={onDismiss}
      >
        <Button fullWidth variant="contained" size="small" onClick={onUpdateCredentials}>
          {hasExistingChartingCredentials ? "Update my login" : "Save my login"}
        </Button>
      </ChatActionCard>
    </Box>
  );
}
